export default function Get_Attr_From_HTML(defaultValue) {
  // var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  let language = document.documentElement.lang;
  if (language)
    return language;
  else
    return defaultValue;
}


// WEBPACK FOOTER //
// ./src/assets/js/getLang.js